/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const HatGlasses = [
  ["path", { d: "M14 18a2 2 0 0 0-4 0" }],
  [
    "path",
    {
      d: "m19 11-2.11-6.657a2 2 0 0 0-2.752-1.148l-1.276.61A2 2 0 0 1 12 4H8.5a2 2 0 0 0-1.925 1.456L5 11"
    }
  ],
  ["path", { d: "M2 11h20" }],
  ["circle", { cx: "17", cy: "18", r: "3" }],
  ["circle", { cx: "7", cy: "18", r: "3" }]
];

export { HatGlasses as default };
//# sourceMappingURL=hat-glasses.js.map
